import { render, staticRenderFns } from "./nutritionMainpageChart.vue?vue&type=template&id=7a5030b1&scoped=true"
import script from "./nutritionMainpageChart.vue?vue&type=script&lang=js"
export * from "./nutritionMainpageChart.vue?vue&type=script&lang=js"
import style0 from "./nutritionMainpageChart.vue?vue&type=style&index=0&id=7a5030b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5030b1",
  null
  
)

export default component.exports